import { useSpring, SpringValue, Interpolation } from '@react-spring/web'
import { useCallback } from 'react'

type ExtrapolateType = 'identity' | 'clamp' | 'extend'

type UseAnimationReturn = [
    SpringValue,
    (range: number[], output: number[], extrapolate?: ExtrapolateType) => Interpolation,
    (to: number, delay?: number) => void
]

const useAnimation = (from: number): UseAnimationReturn => {
    const [{ animatedValue }, api] = useSpring(() => ({
        animatedValue: from,
        delay: 0,
    }))

    const interpolate = useCallback(
        (
            range: number[],
            output: (number | string)[],
            extrapolate?: ExtrapolateType
        ): Interpolation => {
            return animatedValue.to(range, output, extrapolate)
        },
        [animatedValue]
    )
    const startAnimation = useCallback(
        (to: number, delay?: number): void => {
            api.start({ animatedValue: to, delay })
        },
        [api]
    )
    return [animatedValue, interpolate, startAnimation]
}

export default useAnimation
